import { render, staticRenderFns } from "./rcs-live-preview.vue?vue&type=template&id=56d0b552"
import script from "./rcs-live-preview.vue?vue&type=script&lang=js"
export * from "./rcs-live-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports